import { render, staticRenderFns } from "./DeviceActiveTopTen.vue?vue&type=template&id=4454f9aa&scoped=true&"
import script from "./DeviceActiveTopTen.vue?vue&type=script&lang=js&"
export * from "./DeviceActiveTopTen.vue?vue&type=script&lang=js&"
import style0 from "./DeviceActiveTopTen.vue?vue&type=style&index=0&id=4454f9aa&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4454f9aa",
  null
  
)

export default component.exports